<template>

    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :label-width="80" label-position="right">
                                <FormItem :label="t.tag.name" prop="name">
                                    <Input v-model.trim="formItem.name" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.tag.sortOrder" prop="sortOrder">
                                    <Input v-model.trim="formItem.sortOrder" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.tag.status" prop="status">
                                    <Input v-model.trim="formItem.status" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.tag.createBy" prop="createBy">
                                    <Input v-model.trim="formItem.createBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.tag.createTime" prop="createTime">
                                    <Input v-model.trim="formItem.createTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.tag.updateBy" prop="updateBy">
                                    <Input v-model.trim="formItem.updateBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.tag.updateTime" prop="updateTime">
                                    <Input v-model.trim="formItem.updateTime" readonly></Input>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { getTagInfo } from '@/api/tag';

export default {
    name: 'content_tag_detail',
    data() {
        const t = this.$_t();
        return {
            self: this,
            t: t,
            formItem: {
                name: '',
                sortOrder: 0,
                status: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
            },
        };
    },
    methods: {
        async init() {
            const tagInfo = await getTagInfo(this.$route.params.id);
            if (tagInfo.tag != null) {
                this.formItem = tagInfo.tag;
                //状态判断
                if (tagInfo.tag.status === '0') {
                    this.formItem.status = this.t.tag.close;
                } else if (tagInfo.tag.status === '1') {
                    this.formItem.status = this.t.tag.open;
                }
                this.imageList = tagInfo.tag.imageList.map(p => {
                    return { url: p };
                });
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
</style>
